import { Appointment, ProviderDetails } from '@dataTypes/appointment.type'

const getCurrentDateWithTime = (hours: number, minutes: number): string => {
  const now = new Date()
  return new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes,
  ).toISOString()
}

export const mockAppointments: Appointment[] = [
  // Sept 2, 2024
  {
    Id: 1,
    patient_name: 'Phil Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890ab',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Cleaning',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Routine check-up and cleaning.',
    appointment_start_date_time: '10-02-2024 20:00:00',
    appointment_end_date_time: '10-02-2024 20:30:00',
    duration: '30',
    provider_id: 'e67b13f4-225b-487c-9e87-a81e52b9b2d1',
    provider_name: 'Alex Campbell',
    provider_primary_color: '#E4F0D0',
    provider_secondary_color: '#5D9310',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#A4CC6B',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Routine cleaning.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '0e56a816-b07a-4e08-93ed-30d51c33ff0c',
  },
  {
    Id: 2,
    patient_name: 'Claire Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 1,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '10-02-2024 10:45:00',
    appointment_end_date_time: '10-02-2024 11:15:00',
    duration: '30',
    provider_id: 'a0c9262b-05e6-4bba-8ae5-24c8956cf6bd',
    provider_name: 'Anna Ruiz',
    provider_primary_color: '#E5DCFF',
    provider_secondary_color: '#5F21CA',
    provider_third_color: '#F1ECFF',
    provider_fourth_color: '#B99EFC',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '500c623d-e4d0-4aa8-bc67-8a1d541377b3',
  },
  {
    Id: 3,
    patient_name: 'Gloria Pritchett',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890cd',
    phone_number: '555-123-4567',
    appointment_status: 2,
    appointment_type: 'Perio',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Patient requested a follow-up.',
    appointment_start_date_time: '10-02-2024 10:00:00',
    appointment_end_date_time: '10-02-2024 11:00:00',
    duration: '60',
    provider_id: 'e67b13f4-225b-487c-9e87-a81e52b9b2d1',
    provider_name: 'Alex Campbell',
    provider_primary_color: '#E4F0D0',
    provider_secondary_color: '#5D9310',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#A4CC6B',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: '',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: 'bfec2850-ec30-4ea2-b812-5a1b615be0e9',
  },

  // Sept 3, 2024
  {
    Id: 4,
    patient_name: 'Mitchell Pritchett',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890de',
    phone_number: '555-123-4567',
    appointment_status: 3,
    appointment_type: 'Cleaning',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Routine check-up.',
    appointment_start_date_time: '10-03-2024 08:00:00',
    appointment_end_date_time: '10-03-2024 09:00:00',
    duration: '60',
    provider_id: '3712d39e-8b3c-49a7-bfd1-0f8057cae949',
    provider_name: 'Carlos Tan',
    provider_primary_color: '#C6F0ED',
    provider_secondary_color: '#24A1A3',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#2DADA9',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Cleaning appointment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '9f1d8f5f-ba48-4057-bfa4-044f56c86157',
  },
  {
    Id: 5,
    patient_name: 'Manny Delgado',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890ef',
    phone_number: '555-123-4567',
    appointment_status: 4,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal appointment.',
    appointment_start_date_time: '09-03-2024 09:00:00',
    appointment_end_date_time: '09-03-2024 10:00:00',
    duration: '60',
    provider_id: '650dab63-17eb-42c3-a80e-d7f280726998',
    provider_name: 'Andre Thomas',
    provider_primary_color: '#F5C6A4',
    provider_secondary_color: '#B2520D',
    provider_third_color: '#FCF0E7',
    provider_fourth_color: '#ED9A5E',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Root canal.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '9062a69b-60a3-46ec-87d7-a1c5e163f81b',
  },
  {
    Id: 6,
    patient_name: 'Luke Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890fg',
    phone_number: '555-123-4567',
    appointment_status: 5,
    appointment_type: 'Perio',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Periodontal consultation.',
    appointment_start_date_time: '09-03-2024 10:00:00',
    appointment_end_date_time: '09-03-2024 11:00:00',
    duration: '60',
    provider_id: 'e67b13f4-225b-487c-9e87-a81e52b9b2d1',
    provider_name: 'Alex Campbell',
    provider_primary_color: '#E4F0D0',
    provider_secondary_color: '#5D9310',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#A4CC6B',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Perio consultation.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: 'bfec2850-ec30-4ea2-b812-5a1b615be0e9',
  },
  {
    Id: 7,
    patient_name: 'Izzie Stevens',
    patient_id: 'a669c71a-cebc-4d3b-a6c9-bd1a6cdb399c',
    phone_number: '555-123-4567',
    appointment_status: 6,
    appointment_type: 'Perio',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Patient requested a follow-up.',
    appointment_start_date_time: getCurrentDateWithTime(9, 0),
    appointment_end_date_time: getCurrentDateWithTime(9, 30),
    duration: '30',
    provider_id: '202821e9-ffe7-4959-b66a-a122f30f4f08',
    provider_name: 'James Dean',
    provider_primary_color: '#B1D5FB',
    provider_secondary_color: '#185DD8',
    provider_third_color: '#F0F7FE',
    provider_fourth_color: '#65ACF5',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: '',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '0e56a816-b07a-4e08-93ed-30d51c33ff0c',
  },
  {
    Id: 8,
    patient_name: 'Meredith Grey',
    patient_id: 'a669c71a-cebc-4d3b-a6c9-bd1a6cdb399c',
    phone_number: '555-123-4567',
    appointment_status: 7,
    appointment_type: 'Perio',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Patient requested a follow-up.',
    appointment_start_date_time: getCurrentDateWithTime(9, 0),
    appointment_end_date_time: getCurrentDateWithTime(10, 0),
    duration: '60',
    provider_id: 'a0c9262b-05e6-4bba-8ae5-24c8956cf6bd',
    provider_name: 'Anna Ruiz',
    provider_primary_color: '#E5DCFF',
    provider_secondary_color: '#5F21CA',
    provider_third_color: '#F1ECFF',
    provider_fourth_color: '#B99EFC',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: '',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '500c623d-e4d0-4aa8-bc67-8a1d541377b3',
  },
  {
    Id: 9,
    patient_name: "George O'Malley",
    patient_id: 'a669c71a-cebc-4d3b-a6c9-bd1a6cdb399c',
    phone_number: '555-123-4567',
    appointment_status: 8,
    appointment_type: 'Perio',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Patient requested a follow-up.',
    appointment_start_date_time: getCurrentDateWithTime(11, 0),
    appointment_end_date_time: getCurrentDateWithTime(11, 15),
    duration: '15',
    provider_id: '3712d39e-8b3c-49a7-bfd1-0f8057cae949',
    provider_name: 'Carlos Tan',
    provider_primary_color: '#C6F0ED',
    provider_secondary_color: '#24A1A3',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#2DADA9',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: '',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '9f1d8f5f-ba48-4057-bfa4-044f56c86157',
  },

  {
    Id: 10,
    patient_name: 'Manny Delgado',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890ab',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Cleaning',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Routine check-up and cleaning.',
    appointment_start_date_time: '09-12-2024 10:00:00',
    appointment_end_date_time: '09-12-2024 12:00:00',
    duration: '60',
    provider_id: '202821e9-ffe7-4959-b66a-a122f30f4f08',
    provider_name: 'James Dean',
    provider_primary_color: '#B1D5FB',
    provider_secondary_color: '#185DD8',
    provider_third_color: '#F0F7FE',
    provider_fourth_color: '#65ACF5',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Routine cleaning.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '0e56a816-b07a-4e08-93ed-30d51c33ff0c',
  },
  {
    Id: 11,
    patient_name: 'Gloria Pritchette',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-13-2024 08:00:00',
    appointment_end_date_time: '09-13-2024 09:00:00',
    duration: '60',
    provider_id: 'a0c9262b-05e6-4bba-8ae5-24c8956cf6bd',
    provider_name: 'Anna Ruiz',
    provider_primary_color: '#E5DCFF',
    provider_secondary_color: '#5F21CA',
    provider_third_color: '#F1ECFF',
    provider_fourth_color: '#B99EFC',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '500c623d-e4d0-4aa8-bc67-8a1d541377b3',
  },
  {
    Id: 12,
    patient_name: 'Gloria Pritchette',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-14-2024 09:00:00',
    appointment_end_date_time: '09-14-2024 10:00:00',
    duration: '60',
    provider_id: 'a0c9262b-05e6-4bba-8ae5-24c8956cf6bd',
    provider_name: 'Anna Ruiz',
    provider_primary_color: '#E5DCFF',
    provider_secondary_color: '#5F21CA',
    provider_third_color: '#F1ECFF',
    provider_fourth_color: '#B99EFC',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '500c623d-e4d0-4aa8-bc67-8a1d541377b3',
  },
  {
    Id: 13,
    patient_name: 'Lily Pritchette-Tucker',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-17-2024 13:00:00',
    appointment_end_date_time: '09-17-2024 14:00:00',
    duration: '60',
    provider_id: '650dab63-17eb-42c3-a80e-d7f280726998',
    provider_name: 'Andrew Thomas',
    provider_primary_color: '#F5C6A4',
    provider_secondary_color: '#B2520D',
    provider_third_color: '#FCF0E7',
    provider_fourth_color: '#ED9A5E',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '9062a69b-60a3-46ec-87d7-a1c5e163f81b',
  },
  {
    Id: 14,
    patient_name: 'Alex Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-17-2024 09:00:00',
    appointment_end_date_time: '09-17-2024 10:00:00',
    duration: '60',
    provider_id: '3712d39e-8b3c-49a7-bfd1-0f8057cae949',
    provider_name: 'Carlos Tan',
    provider_primary_color: '#C6F0ED',
    provider_secondary_color: '#24A1A3',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#2DADA9',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '9f1d8f5f-ba48-4057-bfa4-044f56c86157',
  },
  {
    Id: 15,
    patient_name: 'Haley Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-17-2024 09:00:00',
    appointment_end_date_time: '09-17-2024 10:00:00',
    duration: '60',
    provider_name: 'Alex Campbell',
    provider_id: 'e67b13f4-225b-487c-9e87-a81e52b9b2d1',
    provider_primary_color: '#E4F0D0',
    provider_secondary_color: '#5D9310',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#A4CC6B',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: 'bfec2850-ec30-4ea2-b812-5a1b615be0e9',
  },
  {
    Id: 16,
    patient_name: 'Luke Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-17-2024 09:00:00',
    appointment_end_date_time: '09-17-2024 10:00:00',
    duration: '60',
    provider_id: '202821e9-ffe7-4959-b66a-a122f30f4f08',
    provider_name: 'James Dean',
    provider_primary_color: '#B1D5FB',
    provider_secondary_color: '#185DD8',
    provider_third_color: '#F0F7FE',
    provider_fourth_color: '#65ACF5',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '0e56a816-b07a-4e08-93ed-30d51c33ff0c',
  },
  {
    Id: 17,
    patient_name: 'Jay Pritchette',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Endo',
    appointment_type_id: 2,
    is_confirmed: true,
    note: 'Root canal treatment.',
    appointment_start_date_time: '09-17-2024 11:00:00',
    appointment_end_date_time: '09-17-2024 12:00:00',
    duration: '60',
    provider_id: 'a0c9262b-05e6-4bba-8ae5-24c8956cf6bd',
    provider_name: 'Anna Ruiz',
    provider_primary_color: '#E5DCFF',
    provider_secondary_color: '#5F21CA',
    provider_third_color: '#F1ECFF',
    provider_fourth_color: '#B99EFC',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Endodontic treatment.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '500c623d-e4d0-4aa8-bc67-8a1d541377b3',
  },
  // {
  //   Id: 18,
  //   patient_name: 'Gehlee Dangca',
  //   patient_id: 'f1234567-abcd-1234-abcd-1234567890bc',
  //   phone_number: '555-123-4567',
  //   appointment_status: 1,
  //   appointment_type: 'Endo',
  //   appointment_type_id: 2,
  //   is_confirmed: true,
  //   note: 'Root canal treatment.',
  //   appointment_start_date_time: '10-02-2024 10:45:00',
  //   appointment_end_date_time: '10-02-2024 11:15:00',
  //   duration: '30',
  //   provider_name: 'Andrew Thomas',
  //   provider_id: '650dab63-17eb-42c3-a80e-d7f280726998',
  //   provider_primary_color: '#F5C6A4',
  //   provider_secondary_color: '#B2520D',
  //   provider_third_color: '#FCF0E7',
  //   provider_fourth_color: '#ED9A5E',
  //   inform_patient_via_phone: false,
  //   inform_patient_via_sms: true,
  //   inform_patient_via_email: false,
  //   inform_patient_via_app: false,
  //   reason_for_visit: 'Endodontic treatment.',
  //   is_recurring: true,
  //   clinic_name: 'ABC Clinic',
  //   insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
  //   policy_number: 'ABCD-1234-DDDD-AAAA',
  //   confirmed: 14,
  //   has_allergies: false,
  //   has_high_blood_pressure: false,
  //   has_profile_tag: false,
  //   is_hygiene: true,
  //   has_insurance: true,
  //   created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
  //   updated_by: '',
  //   files: [],
  //   template: '',
  //   insurance_status: 0,
  //   patient_status: 1,
  //   form_status: 0,
  //   payment_status: 1,
  //   other_status: 0,
  //   isReadOnly: false,
  //   procedure_room_id: '9062a69b-60a3-46ec-87d7-a1c5e163f81b',
  //   visit_every: 'DAILY',
  //   end_after: 'COUNT',
  //   recurrence_interval: 1,
  //   end_count: 8,
  //   recurrenceRule: 'FREQ=DAILY;INTERVAL=2;COUNT=8',
  // },
  {
    Id: 18,
    patient_name: 'John Doe',
    patient_id: 'a669c71a-cebc-4d3b-a6c9-bd1a6cdb399c',
    phone_number: '555-123-4567',
    appointment_status: 7,
    appointment_type: 'Perio',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Patient requested a follow-up.',
    appointment_start_date_time: getCurrentDateWithTime(9, 0),
    appointment_end_date_time: getCurrentDateWithTime(10, 0),
    duration: '60',
    provider_id: 'a0c9262b-05e6-4bba-8ae5-24c8956cf6bd',
    provider_name: 'Anna Ruiz',
    provider_primary_color: '#E5DCFF',
    provider_secondary_color: '#5F21CA',
    provider_third_color: '#F1ECFF',
    provider_fourth_color: '#B99EFC',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: '',
    is_recurring: false,
    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: 'bfec2850-ec30-4ea2-b812-5a1b615be0e9',
  },
  {
    Id: 19,
    patient_name: 'Phil Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890ab',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Cleaning',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Routine check-up and cleaning.',
    appointment_start_date_time: '10-02-2024 20:00:00',
    appointment_end_date_time: '10-02-2024 20:30:00',
    duration: '30',
    provider_id: '202821e9-ffe7-4959-b66a-a122f30f4f08',
    provider_name: 'James Dean',
    provider_primary_color: '#B1D5FB',
    provider_secondary_color: '#185DD8',
    provider_third_color: '#F0F7FE',
    provider_fourth_color: '#65ACF5',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Routine cleaning.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '0e56a816-b07a-4e08-93ed-30d51c33ff0c',
  },
  {
    Id: 20,
    patient_name: 'Phil Dunphy',
    patient_id: 'f1234567-abcd-1234-abcd-1234567890ab',
    phone_number: '555-123-4567',
    appointment_status: 0,
    appointment_type: 'Cleaning',
    appointment_type_id: 1,
    is_confirmed: true,
    note: 'Routine check-up and cleaning.',
    appointment_start_date_time: '10-02-2024 20:00:00',
    appointment_end_date_time: '10-02-2024 20:30:00',
    duration: '30',
    provider_id: '3712d39e-8b3c-49a7-bfd1-0f8057cae949',
    provider_name: 'Carlos Tan',
    provider_primary_color: '#C6F0ED',
    provider_secondary_color: '#24A1A3',
    provider_third_color: '#F4F9EC',
    provider_fourth_color: '#2DADA9',
    inform_patient_via_phone: false,
    inform_patient_via_sms: true,
    inform_patient_via_email: false,
    inform_patient_via_app: false,
    reason_for_visit: 'Routine cleaning.',
    is_recurring: false,

    clinic_name: 'ABC Clinic',
    insurance_id: '039ba200-f7f8-47ec-982f-03204cf6fedb',
    policy_number: 'ABCD-1234-DDDD-AAAA',
    confirmed: 14,
    has_allergies: false,
    has_high_blood_pressure: false,
    has_profile_tag: false,
    is_hygiene: true,
    has_insurance: true,
    created_by: '9090c6b5-ff17-48ad-81b5-74b976250132',
    updated_by: '',
    files: [],
    template: '',
    insurance_status: 0,
    patient_status: 1,
    form_status: 0,
    payment_status: 1,
    other_status: 0,
    isReadOnly: false,
    procedure_room_id: '9f1d8f5f-ba48-4057-bfa4-044f56c86157',
  },
]

export const PROVIDER: ProviderDetails[] = [
  {
    provider_id: '3949c750-ad9e-4d7e-8e61-8c522b0f87f9',
    user_id: '3e06ca38-88c4-4219-9eb9-357e18ef21d8',
    clinic_id: '1372f50e-0704-49c2-b61a-1e4be6d090d1',
    operatory_id: '5b5779ab-9a6a-4edd-9ab8-5198080f04b2',
    first_name: 'Carlyn',
    middle_name: 'Blondell',
    last_name: 'Greasley',
    username: 'cgreasley0',
    gender: 'Female',
    date_of_birth: '2007-08-22',
    pronouns: 'she',
    marital_status: 'Married',
    address: '0484 Sundown Court',
    city: 'Boca Raton',
    state: 'FL',
    zip: '33499',
    cellphone: '561-493-6994',
    email: 'cgreasley0@un.org',
    home_number: '214-105-8470',
    emergency_contact: '303-531-9411',
    state_license_number: '93-9589113',
    state_where_licensed_issued: 'TX',
    state_license_expiry: '1966-10',
    state_rx_id: '65-6785157',
    dea_number: '47-9853231',
    tax_id_type: 'TIN',
    tax_id_number: '32-7251308',
    npi_type: 'individual',
    npi_number: '34-8148456',
    work_position: 'full-time',
    specialty: 'Pediatric Dentistry',
    provider_color: {
      header: '#D8352A',
      background: '#FFCBC8',
      text_color: '#470C08',
      label: 'Red',
    },
    working_days: ['M', 'T', 'W', 'T', 'F'],
    working_hours: '10:00 AM - 6:00 PM',
    created_by: '55b6089e-424e-4f32-90bc-20e909a91960',
    updated_by: '3e06ca38-88c4-4219-9eb9-357e18ef21d8',
    is_hidden: false,
    date_time_created_at: '2024-12-06T08:50:58.000Z',
    date_time_updated_at: '2024-12-06T08:50:58.000Z',
  },
  {
    provider_id: '90922053-9927-4e78-bbb6-d0dabd7f7f47',
    user_id: '3e06ca38-88c4-4219-9eb9-357e18ef21d8',
    clinic_id: 'db08bb8d-915a-46fa-9d1b-ce3eb4cbb6cf',
    operatory_id: '9fc20f2a-6877-413b-bdd8-77a02e419ca2',
    first_name: 'Avery',
    middle_name: 'Bossom',
    last_name: 'Mendel',
    username: 'amendel2',
    gender: 'Male',
    date_of_birth: '1962-03-06',
    pronouns: '',
    marital_status: 'Separated',
    address: '36971 Spohn Pass',
    city: 'Stamford',
    state: 'CT',
    zip: '06905',
    cellphone: '203-204-0118',
    email: 'amendel2@yahoo.co.jp',
    home_number: '505-196-9194',
    emergency_contact: '806-673-3872',
    state_license_number: '28-1261222',
    state_where_licensed_issued: 'NM',
    state_license_expiry: '2001-09',
    state_rx_id: '71-1080981',
    dea_number: '65-7385030',
    tax_id_type: 'SSN',
    tax_id_number: '72-4400101',
    npi_type: 'facility',
    npi_number: '00-6745563',
    work_position: 'full-time',
    specialty: 'Endodontics',
    provider_color: {
      header: '#185DD8',
      background: '#B1D5FB',
      text_color: '#112850',
      label: 'Blue',
    },
    working_days: ['M', 'T', 'W', 'T', 'F'],
    working_hours: '9:00 AM - 5:00 PM',
    created_by: 'ba1569c7-a55b-49fb-aa93-01b467d08936',
    updated_by: 'ba1569c7-a55b-49fb-aa93-01b467d08936',
    is_hidden: false,
    date_time_created_at: '2024-12-06T08:50:58.000Z',
    date_time_updated_at: '2024-12-06T08:50:58.000Z',
  },
  {
    provider_id: 'ad70bb1e-240d-40d6-bd00-0abd472e9cf2',
    user_id: '55b6089e-424e-4f32-90bc-20e909a91960',
    clinic_id: '0f6dcb76-a528-491b-9e1f-fe4d2df5ca46',
    operatory_id: 'd0f1898e-1ed5-4dea-8bf6-e4fe458d79df',
    first_name: 'Ramsay',
    middle_name: 'Bengtsson',
    last_name: 'Kunrad',
    username: 'rkunrad4',
    gender: 'Male',
    date_of_birth: '1955-02-23',
    pronouns: '',
    marital_status: 'Single',
    address: '836 Transport Avenue',
    city: 'Tacoma',
    state: 'WA',
    zip: '98411',
    cellphone: '253-487-3554',
    email: 'rkunrad4@nydailynews.com',
    home_number: '952-526-7897',
    emergency_contact: '816-822-6833',
    state_license_number: '46-0471833',
    state_where_licensed_issued: 'MN',
    state_license_expiry: '1941-05',
    state_rx_id: '06-5850869',
    dea_number: '80-3079454',
    tax_id_type: 'TIN',
    tax_id_number: '28-7151352',
    npi_type: 'facility',
    npi_number: '92-0587087',
    work_position: 'full-time',
    specialty: 'Orthodontics',
    provider_color: {
      header: '#24A1A3',
      background: '#C6F0ED',
      text_color: '#133539',
      label: 'Teal',
    },
    working_days: ['M', 'T', 'W', 'T', 'F'],
    working_hours: '10:00 AM - 6:00 PM',
    created_by: '0f59ee32-9ee0-48e3-b305-261082301970',
    updated_by: 'ba1569c7-a55b-49fb-aa93-01b467d08936',
    is_hidden: false,
    date_time_created_at: '2024-12-06T08:50:58.000Z',
    date_time_updated_at: '2024-12-06T08:50:58.000Z',
  },
  {
    provider_id: 'afe464db-b280-49a0-876f-6614dccdf230',
    user_id: 'ba1569c7-a55b-49fb-aa93-01b467d08936',
    clinic_id: 'db08bb8d-915a-46fa-9d1b-ce3eb4cbb6cf',
    operatory_id: '67b9221b-6ba9-4dbb-8637-869b9f04467e',
    first_name: 'Anatole',
    middle_name: 'Cozins',
    last_name: 'Whittingham',
    username: 'awhittingham3',
    gender: 'Male',
    date_of_birth: '1940-01-18',
    pronouns: '',
    marital_status: 'Separated',
    address: '72 Northland Point',
    city: 'Evansville',
    state: 'IN',
    zip: '47705',
    cellphone: '812-984-5720',
    email: 'awhittingham3@youtu.be',
    home_number: '785-368-3056',
    emergency_contact: '804-627-0103',
    state_license_number: '31-3105121',
    state_where_licensed_issued: 'KS',
    state_license_expiry: '1912-02',
    state_rx_id: '94-6503479',
    dea_number: '88-0071187',
    tax_id_type: 'SSN',
    tax_id_number: '65-6882797',
    npi_type: 'facility',
    npi_number: '59-5612610',
    work_position: 'part-time',
    specialty: 'Pediatric Dentistry',
    provider_color: {
      header: '#5F21CA',
      background: '#E5DCFF',
      text_color: '#270F38',
      label: 'Purple',
    },
    working_days: ['M', 'T', 'W', 'T', 'F'],
    working_hours: '7:00 AM - 3:00 PM',
    created_by: '3e06ca38-88c4-4219-9eb9-357e18ef21d8',
    updated_by: '3e06ca38-88c4-4219-9eb9-357e18ef21d8',
    is_hidden: false,
    date_time_created_at: '2024-12-06T08:50:58.000Z',
    date_time_updated_at: '2024-12-06T08:50:58.000Z',
  },
  {
    provider_id: 'd75c29f5-82f2-4d12-bfe5-5bdf7a28f578',
    user_id: '3e06ca38-88c4-4219-9eb9-357e18ef21d8',
    clinic_id: 'c35b9d87-7135-4b08-9d04-18c41cd91e8a',
    operatory_id: '0f68ef71-b825-4404-8b69-43bd054fcea7',
    first_name: 'Quinta',
    middle_name: 'Lemmanbie',
    last_name: 'Nelle',
    username: 'qnelle1',
    gender: 'Female',
    date_of_birth: '1913-07-19',
    pronouns: 'she',
    marital_status: 'Divorced',
    address: '9 Monterey Terrace',
    city: 'Vienna',
    state: 'VA',
    zip: '22184',
    cellphone: '571-293-3300',
    email: 'qnelle1@tripadvisor.com',
    home_number: '313-387-1206',
    emergency_contact: '812-561-6591',
    state_license_number: '47-7891049',
    state_where_licensed_issued: 'MI',
    state_license_expiry: '2002-01',
    state_rx_id: '85-0043212',
    dea_number: '17-2591812',
    tax_id_type: 'TIN',
    tax_id_number: '02-6171303',
    npi_type: 'organization',
    npi_number: '60-9967551',
    work_position: 'part-time',
    specialty: 'Oral Surgery',
    provider_color: {
      header: '#5D9310',
      background: '#E4F0D0',
      text_color: '#19250E',
      label: 'Green',
    },
    working_days: ['M', 'T', 'W', 'T', 'F'],
    working_hours: '8:30 AM - 4:30 PM',
    created_by: 'dc290c9f-91ae-4ac3-8501-4ee157e318f1',
    updated_by: '0f59ee32-9ee0-48e3-b305-261082301970',
    is_hidden: false,
    date_time_created_at: '2024-12-06T08:50:58.000Z',
    date_time_updated_at: '2024-12-06T08:50:58.000Z',
  },
]

export const PROCEDURE_ROOM = [
  {
    operatory_id: '0f68ef71-b825-4404-8b69-43bd054fcea7',
    clinic_id: 'c35b9d87-7135-4b08-9d04-18c41cd91e8a',
    name: 'Room 2',
    color: '#86a35b',
    is_hidden: false,
    created_by: null,
    updated_by: null,
    date_time_created_at: '2024-11-23T06:25:52.000Z',
    date_time_updated_at: '2024-11-23T06:25:52.000Z',
    providers: [
      {
        provider_id: 'd75c29f5-82f2-4d12-bfe5-5bdf7a28f578',
        first_name: 'Quinta',
        last_name: 'Nelle',
        username: 'qnelle1',
        operatory_id: '0f68ef71-b825-4404-8b69-43bd054fcea7',
        work_position: 'part-time',
      },
    ],
  },
  {
    operatory_id: '5b5779ab-9a6a-4edd-9ab8-5198080f04b2',
    clinic_id: 'ed6ea79f-f56b-49a3-af58-34bb3084aca0',
    name: 'Room 3',
    color: '#895259',
    is_hidden: false,
    created_by: null,
    updated_by: null,
    date_time_created_at: '2024-11-23T06:25:52.000Z',
    date_time_updated_at: '2024-11-23T06:25:52.000Z',
    providers: [
      {
        provider_id: '3949c750-ad9e-4d7e-8e61-8c522b0f87f9',
        first_name: 'Carlyn',
        last_name: 'Greasley',
        username: 'cgreasley0',
        operatory_id: '5b5779ab-9a6a-4edd-9ab8-5198080f04b2',
        work_position: 'full-time',
      },
      {
        provider_id: 'afe464db-b280-49a0-876f-6614dccdf230',
        first_name: 'Anatole',
        last_name: 'Whittingham',
        username: 'awhittingham3',
        operatory_id: '5b5779ab-9a6a-4edd-9ab8-5198080f04b2',
        work_position: 'part-time',
      },
    ],
  },
  {
    operatory_id: '67b9221b-6ba9-4dbb-8637-869b9f04467e',
    clinic_id: 'c35b9d87-7135-4b08-9d04-18c41cd91e8a',
    name: 'Room 5',
    color: '#0a0707',
    is_hidden: false,
    created_by: null,
    updated_by: null,
    date_time_created_at: '2024-11-23T06:25:52.000Z',
    date_time_updated_at: '2024-11-23T06:25:52.000Z',
    providers: [],
  },
  {
    operatory_id: '9fc20f2a-6877-413b-bdd8-77a02e419ca2',
    clinic_id: 'ed6ea79f-f56b-49a3-af58-34bb3084aca0',
    name: 'Room 4',
    color: '#3ee9fb',
    is_hidden: false,
    created_by: null,
    updated_by: null,
    date_time_created_at: '2024-11-23T06:25:52.000Z',
    date_time_updated_at: '2024-11-23T06:25:52.000Z',
    providers: [
      {
        provider_id: '90922053-9927-4e78-bbb6-d0dabd7f7f47',
        first_name: 'Avery',
        last_name: 'Mendel',
        username: 'amendel2',
        operatory_id: '9fc20f2a-6877-413b-bdd8-77a02e419ca2',
        work_position: 'full-time',
      },
    ],
  },
  {
    operatory_id: 'd0f1898e-1ed5-4dea-8bf6-e4fe458d79df',
    clinic_id: 'db08bb8d-915a-46fa-9d1b-ce3eb4cbb6cf',
    name: 'Room 1',
    color: '#085e3a',
    is_hidden: false,
    created_by: null,
    updated_by: null,
    date_time_created_at: '2024-11-23T06:25:52.000Z',
    date_time_updated_at: '2024-11-23T06:25:52.000Z',
    providers: [
      {
        provider_id: 'ad70bb1e-240d-40d6-bd00-0abd472e9cf2',
        first_name: 'Ramsay',
        last_name: 'Kunrad',
        username: 'rkunrad4',
        operatory_id: 'd0f1898e-1ed5-4dea-8bf6-e4fe458d79df',
        work_position: 'full-time',
      },
    ],
  },
]
